import { useFeatures } from './FeatureGate';
import FeatureUnavailable from './FeatureUnavailable';

/**
 * FeatureRouteGuard — wraps a Route's element and renders a friendly
 * "not available for your institution" page when the feature is disabled.
 * Loads nothing itself; uses the feature context populated at login by
 * FeatureFlagProvider (GET /features/me). Fail-open: while features are not
 * loaded the content renders (the backend still enforces 403s).
 */
const LABELS = {
  ai_agents: 'AI Agents',
  sidebar_interviewer: 'AI Interviewer (Student Sidebar)',
  // sub-feature labels (used when the `sub` prop is provided)
  ai_interviewer: 'AI Interviewer',
  ai_resume_scorer: 'AI Resume Scorer',
  ai_tutor: 'AI Tutor',
  ai_counsellor: 'AI Counsellor',
  ai_analysis: 'AI Analysis',
  lms: 'LMS',
  vetting: 'Vetting & Compliance',
  discussions: 'Groups & Discussions',
  certificates: 'Certificates',
  jobs: 'Jobs & Placement Drives',
  proctoring: 'Proctoring',
  payments: 'Payments',
  mantrika: 'Mantrika Vendor Integration',
  navigatelabs: 'NavigateLabs Integration',
  messages: 'Messages',
  schedule: 'My Schedule',
  platform_feedback: 'Platform Feedback',
};

export default function FeatureRouteGuard({ feature, sub, children }) {
  const { isEnabled, isSubEnabled } = useFeatures();
  const allowed = sub ? isSubEnabled(feature, sub) : isEnabled(feature);
  if (allowed) return children;
  const label = sub ? (LABELS[sub] || LABELS[feature] || 'This feature')
                    : (LABELS[feature] || 'This feature');
  return <FeatureUnavailable featureLabel={label} />;
}
